import { Tag } from "antd";
import { PROJECT_STATUS_LABELS } from "../../constants";

export const ProjectStatus = ({ status }) => {
  const colors = {
    PENDING: "blue",
    ONGOING: "cyan",
    COMPLETED: "green",
    OTHERS: "orange",
  };

  return <Tag color={colors[status]}>{PROJECT_STATUS_LABELS[status]}</Tag>;
};
